import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "sticky bg-black px-4 py-4 text-white lg:top-[120px] lg:px-5 lg:py-10 xl:py-16",
    "data-event-sidebar": ""
};
const _hoisted_2 = {
    key: 0,
    class: "font-sans !font-bold"
};
const _hoisted_3 = {
    key: 0,
    class: "mb-7"
};
const _hoisted_4 = { class: "font-sans !font-bold" };
const _hoisted_5 = {
    key: 0,
    class: "-mt-8 mb-14"
};
import { computed } from 'vue';
import AccordionToggle from '@atoms/AccordionToggle.vue';
import { MqResponsive } from 'vue3-mq';
import EventSessionInformation from '@molecules/EventSessionInformation.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EventSidebar',
    props: {
        eventSessions: {},
        isSoldOut: { type: Boolean },
        isManualEvent: { type: Boolean },
        isPastEvent: { type: Boolean },
        hasLiveStream: { type: Boolean },
        isVirtualEvent: { type: Boolean },
        hasMultipleDates: { type: Boolean },
        isComingSoon: { type: Boolean },
        isExternalEvent: { type: Boolean },
        externalEventBookingNote: {},
        waitlistAvailable: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const sidebarHasValues = computed(() => {
            if (props.isVirtualEvent)
                return false;
            if (props.isPastEvent || props.isComingSoon)
                return true;
            if (props.isExternalEvent && props.eventSessions.length !== 0)
                return true;
            if (props.isManualEvent)
                return false;
            return hasSessions.value;
        });
        const hasSessions = computed(() => {
            return Object.keys(props.eventSessions).length > 0;
        });
        const sidebarMobileTitle = computed(() => {
            if (props.isSoldOut && props.waitlistAvailable)
                return 'See times and join waiting list';
            if (props.hasMultipleDates)
                return 'See times and book';
            if (props.isSoldOut)
                return 'Fully booked';
            return 'Book now';
        });
        const isPastOrComingSoon = computed(() => {
            return props.isPastEvent || props.isComingSoon;
        });
        const displayExternalEventBookingNote = computed(() => {
            return props.isExternalEvent && props.externalEventBookingNote.length > 0;
        });
        const titleCopy = computed(() => {
            if (props.isPastEvent)
                return 'This event has now passed';
            if (props.isComingSoon)
                return 'Booking opening soon';
            if (props.isSoldOut)
                return 'Fully booked';
            return 'Book now';
        });
        return (_ctx, _cache) => {
            return (sidebarHasValues.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (isPastOrComingSoon.value)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(titleCopy.value), 1))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (hasSessions.value)
                                ? (_openBlock(), _createBlock(_unref(MqResponsive), {
                                    key: 0,
                                    group: ""
                                }, {
                                    "md-": _withCtx(() => [
                                        _createVNode(AccordionToggle, {
                                            title: sidebarMobileTitle.value,
                                            class: "!text-md"
                                        }, {
                                            default: _withCtx(() => [
                                                (displayExternalEventBookingNote.value)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.externalEventBookingNote), 1))
                                                    : _createCommentVNode("", true),
                                                _createVNode(EventSessionInformation, {
                                                    isManualEvent: _ctx.isManualEvent,
                                                    hasLiveStream: _ctx.hasLiveStream,
                                                    sessions: _ctx.eventSessions
                                                }, null, 8, ["isManualEvent", "hasLiveStream", "sessions"])
                                            ]),
                                            _: 1
                                        }, 8, ["title"])
                                    ]),
                                    "lg+": _withCtx(() => [
                                        _createElementVNode("h3", _hoisted_4, _toDisplayString(titleCopy.value), 1),
                                        (displayExternalEventBookingNote.value)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.externalEventBookingNote), 1))
                                            : _createCommentVNode("", true),
                                        _createVNode(EventSessionInformation, {
                                            isManualEvent: _ctx.isManualEvent,
                                            hasLiveStream: _ctx.hasLiveStream,
                                            sessions: _ctx.eventSessions
                                        }, null, 8, ["isManualEvent", "hasLiveStream", "sessions"])
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ], 64))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
